import * as Types from '__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PublicHolidaysQueryVariables = Types.Exact<{
  endDate?: Types.InputMaybe<Types.Scalars['ISO8601Date']['input']>;
  startDate?: Types.InputMaybe<Types.Scalars['ISO8601Date']['input']>;
}>;


export type PublicHolidaysQuery = { __typename?: 'Query', publicHolidays: Array<string> };


export const PublicHolidaysDocument = gql`
    query publicHolidays($endDate: ISO8601Date, $startDate: ISO8601Date) {
  publicHolidays(endDate: $endDate, startDate: $startDate)
}
    `;

/**
 * __usePublicHolidaysQuery__
 *
 * To run a query within a React component, call `usePublicHolidaysQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicHolidaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicHolidaysQuery({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function usePublicHolidaysQuery(baseOptions?: Apollo.QueryHookOptions<PublicHolidaysQuery, PublicHolidaysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicHolidaysQuery, PublicHolidaysQueryVariables>(PublicHolidaysDocument, options);
      }
export function usePublicHolidaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicHolidaysQuery, PublicHolidaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicHolidaysQuery, PublicHolidaysQueryVariables>(PublicHolidaysDocument, options);
        }
export function usePublicHolidaysSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PublicHolidaysQuery, PublicHolidaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublicHolidaysQuery, PublicHolidaysQueryVariables>(PublicHolidaysDocument, options);
        }
export type PublicHolidaysQueryHookResult = ReturnType<typeof usePublicHolidaysQuery>;
export type PublicHolidaysLazyQueryHookResult = ReturnType<typeof usePublicHolidaysLazyQuery>;
export type PublicHolidaysSuspenseQueryHookResult = ReturnType<typeof usePublicHolidaysSuspenseQuery>;
export type PublicHolidaysQueryResult = Apollo.QueryResult<PublicHolidaysQuery, PublicHolidaysQueryVariables>;